"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardHeader = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var CardHeader = function CardHeader(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      children = _ref.children,
      extend = _ref.extend;
  return /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: [cardHeaderCSS, extend]
  }, /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: {// alignSelf: "flex-start",
    }
  }, /*#__PURE__*/_react["default"].createElement(_.Text, {
    variant: "large"
  }, title), /*#__PURE__*/_react["default"].createElement(_.Spacer, {
    size: 0.5
  }), subTitle && /*#__PURE__*/_react["default"].createElement(_.Text, {
    variant: "small",
    diffuse: true
  }, subTitle)), /*#__PURE__*/_react["default"].createElement(_.Spacer, null), /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end'
    }
  }, children));
};

exports.CardHeader = CardHeader;

var cardHeaderCSS = function cardHeaderCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      colors = _ref2$theme.colors,
      grid = _ref2$theme.grid;
  return {
    position: 'relative',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: "1px solid ".concat(colors.border),
    paddingBottom: 2 * grid // background: "hotpink",

  };
};